import { useCallback, useEffect, useState } from 'react';
import { comunidadAdapter, ComunidadPublishedContent } from '@/hooks/api/comunidad';

/** Trae el contenido YA PUBLICADO de Comunidad (novedades + newsletter) — lo que haya
 *  quedado en borrador sin publicar en el panel de admin nunca llega hasta acá. */
export function useComunidadContent() {
  const [content, setContent] = useState<ComunidadPublishedContent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // Si falla, la pantalla sigue en pie: cada bloque muestra su propio aviso (ver `error`) en
  // vez de romper todo Comunidad con un error sin atrapar.
  const reload = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const data = await comunidadAdapter.getContent();
      setContent(data);
    } catch {
      setContent(null);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { content, loading, error, reload };
}
